import Vue from 'vue'
import Router from 'vue-router'
import login from '../components/login/login'
import ytlogin from '../components/login/ytlogin'
import wxLogin from '../components/login/wxLogin'
import forgetpassword from '../components/login/forgetpassword'
import resetpassword from '../components/login/resetpassword'
import resetpassword2 from '../components/login/resetpassword2'
import register from '../components/login/register'
import index from '../components/content/index'
import forthcomeing from '../components/content/indextomeeting/forthcomeing_meeting'
import attendmeeting from '../components/content/attendmeeting'
import personalmode from '../components/content/personalmode'
import nowmeeting from '../components/content/nowmeeting'
import attendmeetinglist from '../components/content/attendmeetinglist'
import meetingact from '../components/content/meetingact'
import meetingnotice from '../components/content/meetnotice'
import meetingdetail from '../components/content/meetdetail'
import roomchoice from '../components/content/roomchoice'
import historymeeting from '../components/content/indextomeeting/historymeeting'
import historyplaymeeting from '../components/content/indextomeeting/historyplaymeeting'
import forthmeetingvmr from '../components/content/indextomeeting/forthmeetingvmr'
import help from '../components/content/help'
import changemeeting from '../components/content/changemeeting'
import terminaladd from '../components/content/terminaladd'
import usermessage from '../components/content/usermessage'
import userlist from '../components/content/userlist'
import meetingtemplate from '../components/content/indextomeeting/meetingtemplate'
import meetingtemplateedit from '../components/content/indextomeeting/meetingtemplate_edit'
import terminalcontrol from '../components/content/terminalcontrol'
import terminalcontrolPctest from '../components/content/terminalcontrolPctest'
import terminaltimeinfo from '../components/content/terminaltimeinfo'
import broadcastpolling from '../components/content/broadcastpolling'
import oneclickpolling from '../components/content/oneclickpolling'
import checkinrecords from '../components/content/checkinrecord'
import doublestream from '../components/content/doublestream'
import departmentListdetail from '../components/content/departmentListdetail'
import Sxt from '../components/content/sxt'
import vvMeetingList from '../components/content/vvMeetingList'
import vvScan from '../components/content/vvScan'
import DetailedInfo from '../components/content/VVinfo'
Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: (t) => {
        if (t.query.meetinguuid) {
          return '/meetingdetail'
        } else {
          return '/login'
        }
      }
      // {"meta":{},"path":"/","hash":"","query":{"meetinguuid":"123"},"params":{},"fullPath":"/?meetinguuid=123","matched":[{"path":"","regex":{"keys":[]},"components":{},"instances":{},"meta":{},"props":{}}]}
    },
    {
      path: '/login',
      component: login
    },
    {
      path: '/ytlogin',
      component: ytlogin
    },
    {
      path: '/forgetpassword',
      component: forgetpassword
    },
    {
      path: '/resetpassword',
      component: resetpassword
    },
    {
      path: '/resetpassword2',
      component: resetpassword2
    },
    {
      path: '/register',
      component: register
    },
    {
      path: '/index',
      component: index
    },
    {
      path: '/wxLogin',
      component: wxLogin
    },
    {
      path: '/forthcomeing',
      component: forthcomeing
    },
    {
      path: '/historymeeting',
      component: historymeeting
    },
    {
      path: '/historyplaymeeting',
      component: historyplaymeeting
    },
    {
      path: '/attendmeeting',
      component: attendmeeting
    },
    {
      path: '/personalmode',
      component: personalmode
    },
    {
      path: '/nowmeeting',
      component: nowmeeting
    },
    {
      path: '/attendmeetinglist',
      component: attendmeetinglist
    },
    {
      path: '/roomchoice',
      name: 'roomchoice',
      component: roomchoice
    },
    {
      path: '/meetingact',
      name: 'meetingact',
      component: meetingact
    },
    {
      path: '/meetingnotice',
      component: meetingnotice
    },
    {
      path: '/meetingdetail',
      name: 'meetingdetail',
      component: meetingdetail
    },
    {
      path: '/forthmeetingvmr',
      component: forthmeetingvmr
    },
    {
      path: '/help',
      component: help
    },
    {
      path: '/changemeeting',
      name: 'changemeeting',
      component: changemeeting
    },
    {
      path: '/terminaladd',
      name: 'terminaladd',
      component: terminaladd
    },
    {
      path: '/usermessage',
      component: usermessage
    },
    {
      path: '/userlist',
      component: userlist
    },
    {
      path: '/meetingtemplate',
      component: meetingtemplate
    },
    {
      path: '/meetingtemplateedit',
      component: meetingtemplateedit
    },
    {
      path: '/terminalcontrol',
      component: terminalcontrol
    },
    {
      name: 'terminalcontrolPctest',
      path: '/terminalcontrolPctest',
      name: 'terminalcontrolPctest',
      component: terminalcontrolPctest
    },
    {
      path: '/terminaltimeinfo',
      component: terminaltimeinfo
    },
    {
      path: '/broadcastpolling',
      component: broadcastpolling
    },
    {
      path: '/oneclickpolling',
      component: oneclickpolling
    },
    {
      path: '/checkinrecords',
      component: checkinrecords
    },
    {
      path: '/doublestream',
      component: doublestream
    },
    {
      path: '/Sxt',
      component: Sxt,
      name: 'Sxt'
    },
    {
      path: '/departmentListdetail',
      component: departmentListdetail
    },
    {
      path: '/vvMeetingList',
      component: vvMeetingList
    },
    {
      path: '/vvScan',
      component: vvScan
    },
    {
      path:'/DetailedInfo',
      component:DetailedInfo
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js